import { Modal } from 'react-bootstrap';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { vehicleService } from "../../Services/vehicle.service";
import { ToastComponent } from "../../Pages/Components/ToastComponent";
import {
    ColumnDirective,
    ColumnsDirective,
    GridComponent,
    Inject,
    Page,
    ExcelExport,
    PdfExport,
    Filter
} from '@syncfusion/ej2-react-grids';
import { FaCarAlt, FaRegFileExcel, FaRegFilePdf } from "react-icons/fa";
import Spinner from "../Components/Spinner";
import EmptyData from "../../components/EmptyData";

export default function VehiclesStatus(props) {
    const gridRef = useRef(null);
    const bodyRef = useRef(null);
    const headerRef = useRef(null);
    const [pageSize, setPageSize] = useState(10);
    const [bodyHeight, setBodyHeight] = useState(null);
    const [dataLoading, setDataLoading] = useState(true);
    const [dataFilter, setDataFilter] = useState([]);
    const [toastParams, setToastParams] = useState("");

    const handleCloseModal = () => props.handleCloseModal(true);

    const handleClickPdfExport = () => {
        setToastParams(
            JSON.stringify({
                show: true,
                title: "Atenção",
                body: "Em desenvolvimento",
                color: "Warning",
            })
        );

        //gridRef.current?.pdfExport();
    };

    const handleClickExcelExport = () => {
        setToastParams(
            JSON.stringify({
                show: true,
                title: "Atenção",
                body: "Em desenvolvimento",
                color: "Warning",
            })
        );
        //gridRef.current?.excelExport();
    };

    const recomputePageSize = () => {
        const grid = gridRef.current;
        if (!grid) return;

        const contentEl = grid.getContent?.();
        const contentH = contentEl?.clientHeight ?? 0;
        if (contentH <= 0) return;

        const firstRow = grid.getRows?.()?.[0];
        const rowH = firstRow?.getBoundingClientRect?.().height
            ?? grid.rowHeight
            ?? 36;

        const computed = Math.max(5, Math.floor(contentH / rowH)) - 1;
        setPageSize(computed);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await vehicleService.positionsByStatus(props.code);
                if (response) {
                    setDataFilter(response);
                }
            } catch (error) {
                console.error("Erro ao buscar status do veículo:", error);
            } finally {
                setDataLoading(false);
            }
        };
        fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useLayoutEffect(() => {
        const computeBodyHeight = () => {
            // Altura total da viewport
            const vh = window.innerHeight;

            // Altura do header da modal
            const headerH = headerRef.current?.offsetHeight ?? 0;

            // Se tiver footer, some aqui:
            const footerH = 0;

            // Padding/margens internos do body (ajuste fino, 24 geralmente funciona bem)
            const bodyPadding = 24;

            // Altura disponível para o conteúdo do Body
            const h = vh - headerH - footerH - bodyPadding;
            setBodyHeight(Math.max(200, h)); // evita valores muito pequenos
        };

        // calcula agora e ao redimensionar
        computeBodyHeight();
        window.addEventListener('resize', computeBodyHeight);
        return () => window.removeEventListener('resize', computeBodyHeight);
    }, []);

    useEffect(() => {
        const onResize = () => recomputePageSize();
        window.addEventListener('resize', onResize);
        const t = setTimeout(recomputePageSize, 0);

        return () => {
            window.removeEventListener('resize', onResize);
            clearTimeout(t);
        };
  // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bodyHeight]);

    return (
        <Modal
            id="modalVehicles"
            show={true}
            backdrop="static"
            size="lg"
            fullscreen={true}
            onHide={handleCloseModal}
            centered
        >

            <Modal.Header ref={headerRef} closeButton>
                <Modal.Title>Status de veículos <FaCarAlt /></Modal.Title>
            </Modal.Header>

            <Modal.Body
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: bodyHeight ? `${bodyHeight}px` : undefined,
                    paddingBottom: 0
                }}
            >
                <ToastComponent params={toastParams} closeToast={() => setToastParams(JSON.stringify({ show: false }))} />

                <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                    <button className="btn btn-primary" onClick={handleClickPdfExport}>
                        <FaRegFilePdf style={{ marginRight: 4 }} />
                        PDF
                    </button>
                    <button className="btn btn-primary" onClick={handleClickExcelExport}>
                        <FaRegFileExcel style={{ marginRight: 4 }} />
                        Excel
                    </button>
                </div>

                {dataLoading ? (
                    <div className="d-flex justify-content-center my-5">
                        <Spinner />
                    </div>
                ) : (
                    <div
                        ref={bodyRef}
                        style={{
                            flex: 1,
                            minHeight: 0,
                            marginTop: 16
                        }}
                    >
                        <GridComponent
                            ref={gridRef}
                            dataSource={dataFilter}
                            allowPaging
                            allowFiltering={true}
                            filterSettings={{ type: "Menu" }}
                            pageSettings={{ pageSize }}
                            allowExcelExport
                            allowPdfExport
                            height="100%"
                            locale="pt-BR"
                            dataBound={recomputePageSize}
                            rowDataBound={(args) => {
                                args.row.style.cursor = "pointer";
                            }}
                            emptyRecordTemplate={() => <EmptyData />}
                        >
                            <ColumnsDirective>
                                <ColumnDirective clipMode="EllipsisWithTooltip" field="licensePlate" headerText="Placa" width="100" />
                                <ColumnDirective clipMode="EllipsisWithTooltip" field="vehicleGroupName" headerText="Grupo do veiculo" width="100" />
                                <ColumnDirective clipMode="EllipsisWithTooltip" field="positionDateTime" headerText="Data e Hora" width="70" format="dd/MM/yy HH:mm:ss" type="dateTime" />
                                <ColumnDirective clipMode="EllipsisWithTooltip" field="location" headerText="Localização" width="150" />
                                <ColumnDirective
                                    headerText="Mapa"
                                    width="100"
                                    textAlign="Center"
                                    clipMode="EllipsisWithTooltip"
                                    template={(props) => (
                                        <a
                                            href={`https://www.google.com/maps?q=${props.latitude},${props.longitude}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Abrir no Google Maps"
                                        >
                                            <img
                                                src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Google_Maps_icon_%282015-2020%29.svg/2048px-Google_Maps_icon_%282015-2020%29.svg.png"
                                                width={25}
                                                height={25}
                                                alt="imagem-mapa"
                                            />
                                        </a>
                                    )}
                                />


                            </ColumnsDirective>
                            <Inject services={[Page, ExcelExport, PdfExport, Filter]} />
                        </GridComponent>
                    </div>
                )}
            </Modal.Body>
        </Modal >
    );
}
